// extracted by mini-css-extract-plugin
module.exports = {"section__wrapper":"b_b contentWrapper","text__wrapper":"b_c","text__header":"b_d sectionHeader","text__body":"b_f header","text__h1":"b_g","bar":"b_h"};